import { SC } from "../helper/ServerCall";

export const itemCategoryService = {
    getItemCategories
}

function getItemCategories() {
    return SC.getCall(`getItemCategories`);
}